import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';

export function changeApprovalType({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let approvalType = sectionComponent.customForm.current?.state.componentDataSource.ApprovalTypeId.filter(c => c.Value === parameter)[0];
  sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, parameter);
  let page = pageComponent.createPage.current?.state.page;
  page.sectionList.filter(c => c.name === 'Approval')[0].componentList.filter(c => c.type === sectionComponent.state.componentType)[0].groupList.map((group, i) => {
    if (group.type !== null) {
      group.show = false;
    }
    return group;
  })
  page.sectionList.filter(c => c.name === 'Approval')[0].componentList.filter(c => c.type === sectionComponent.state.componentType)[0].groupList.map((group, i) => {
    if (group.type === null || group.type.split(',').map(item => item.trim()).indexOf(approvalType.Data.toString()) >= 0) {
      group.show = true;
    }
    return group;
  })
  pageComponent.createPage.current?.setState({ page });
}

export function changeIssueDate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  // 兼容两个入口：Job 详情页数据在 state.jobData，Approval 详情页数据在 state.approvalData
  // 两者均带有自动填充所需的 Job 字段(StageNum/PrimaryNatureOfWorkCode/NatureOfWorkCode/PptPropertyTypeName/ModuleId)
  const jobData = pageComponent.state.jobData ?? pageComponent.state.approvalData ?? {};
  const approvalTypeId = sectionComponent.customForm.current?.formRef.current?.getFieldValue('ApprovalTypeId');
  if (isNcc10aDecisionNotice(jobData, sectionComponent, pageComponent, approvalTypeId)) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addYearMoment(parameter, 1), config.format.date));
  } else if (jobData.PrimaryNatureOfWorkCode == '2' && jobData.ModuleId == 1 && (approvalTypeId == 1 || approvalTypeId == 2)) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('CommenceByDate', moment(globalFunction.addMonthMoment(parameter, 6), config.format.date));
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addYearMoment(parameter, 1), config.format.date));
  } else if (isParsedIntGreaterThanOne(jobData.StageNum) && sectionComponent.customForm.current?.formRef.current?.getFieldValue('CompletedByDate') != null && jobData.ModuleId == 1) {
    //不作操作
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('CommenceByDate', moment(globalFunction.addYearMoment(parameter, 1), config.format.date));
  } else {
    if (approvalTypeId == 5) {
      if (jobData.NatureOfWorkCode?.indexOf('Q6') >= 0) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addMonthMoment(parameter, 9), config.format.date));
      } else if (jobData.NatureOfWorkCode?.indexOf('Q4') >= 0 || jobData.NatureOfWorkCode?.indexOf('Q5') >= 0) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('CommenceByDate', moment(globalFunction.addMonthMoment(parameter, 2), config.format.date));
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addYearMoment(parameter, 1), config.format.date));
      } else {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addYearMoment(parameter, 2), config.format.date));
      }
    } else {
      sectionComponent.customForm.current?.formRef.current?.setFieldValue('CommenceByDate', moment(globalFunction.addYearMoment(parameter, 1), config.format.date));
      if (jobData.PptPropertyTypeName == 'Commercial' && jobData.ModuleId == 1) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addYearMoment(parameter, 3), config.format.date));
      } else {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', moment(globalFunction.addYearMoment(parameter, 2), config.format.date));
      }
    }
  }
}

function isNcc10aDecisionNotice(jobData, sectionComponent, pageComponent, approvalTypeId) {
  if (jobData.CompanyId != 3 || !hasOnlyNcc10a(jobData, pageComponent)) {
    return false;
  }

  let approvalType = sectionComponent.customForm.current?.state.componentDataSource.ApprovalTypeId?.filter(c => c.Value == approvalTypeId)[0];
  return approvalType?.Key?.toLowerCase()?.indexOf('decision notice') >= 0;
}

function hasOnlyNcc10a(jobData, pageComponent) {
  if (Array.isArray(jobData.JobNccClassList) && jobData.JobNccClassList.length > 0) {
    // NCC Class Section 仅一条 10a 时，Decision Notice 的 Completed By 按 Issue Date + 1 年计算。
    return jobData.JobNccClassList.length === 1 && jobData.JobNccClassList[0]?.NccClass?.trim().toLowerCase() === '10a';
  }

  const jobNccClassSectionData = globalFunction.getSectionComponent(pageComponent, 'JobNccClass')?.child.current?.state.data;
  if (Array.isArray(jobNccClassSectionData) && jobNccClassSectionData.length > 0) {
    return jobNccClassSectionData.length === 1 && jobNccClassSectionData[0]?.NccClass?.trim().toLowerCase() === '10a';
  }

  if (typeof jobData.NccClass === 'string') {
    const nccClassList = jobData.NccClass.split(',').map(c => c.trim().toLowerCase()).filter(c => c !== '');
    return nccClassList.length === 1 && nccClassList[0] === '10a';
  }

  return false;
}

export function clearIssueDate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('CommenceByDate', undefined);
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompletedByDate', undefined);
}

function isParsedIntGreaterThanOne(str) {
  // 尝试将字符串转换为整数
  let parsedInt = parseInt(str);

  // 检查是否成功转换为整数且大于1
  if (!isNaN(parsedInt) && parsedInt > 1) {
    return true;
  } else {
    return false;
  }
}

export function addSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
}

export function editSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
}

export function addApprovalPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('ApprovalNo', pageComponent.state.jobData.ApprovalNo);
  if (pageComponent.state.jobData.ModuleConfig.PopulateApprovalIssueDateByDefault === true) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('IssueDate', moment(new Date(), config.format.date));
    changeIssueDate({
      parameter: moment(new Date(), config.format.date), sectionComponent, pageComponent, sectionName, uie
    });
  }
}

export function editApprovalPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('ApprovalNo', pageComponent.state.jobData.ApprovalNo);
}
